import {useMediaQuery} from '@mui/material'
import React, {useEffect, useState} from 'react'
import {FiBell, FiLogIn} from 'react-icons/fi'
import {Logo} from '../../../../components/Logo/Logo'
import SadatJobsNavbar from '../../../../components/MobileNavbar/SadatJobsNavbar'
import classes from './EmployeeHeader.module.css'
import {Link, useHistory, NavLink} from 'react-router-dom'
import {Notification} from "../../Notification/Notification";

interface Props {
    without?: boolean;
}

export const EmployeeHeader: React.FC<Props> = (props) => {
    const [notifiShow, setnotifiShow] = useState<boolean>(false)
    const history = useHistory()
    useEffect(() => {
        window.onclick = (event: any) => {
            let ele: any = document.getElementById("NotificationIcon");
            if(ele && ele.contains(event.target) === false) {
                setnotifiShow(false);
            }
        }
    }, [])
    const matches = useMediaQuery('(max-width:1094px)')
    if(matches) return <EmployeeMobileHeader without={props.without} doLogout={()=>history.replace('/logout')}/>
    else
        return (
                <div className={classes.header}>
                    <div className={classes.NavIcon + '    cursorpointer'} onClick={()=>history.replace('/logout')}>
                        <FiLogIn color='#BBBBBB' size={30}/>
                    </div>
                    <NavLink to={'/'}>
                    <Logo/>
                    </NavLink>
                    <div id={"NotificationIcon"} className={classes.notificard}>
                        <FiBell className={`cursorpointer    ${notifiShow ? " opennoti opennotibgwhite w-0 h-0 " : ""}  ` + classes.NavIcon}
                                color='#BBBBBB' size={30} onClick={() => setnotifiShow(!notifiShow)}/>

                        {notifiShow ? <div className={classes.notificontent}><Notification/></div> : ""}
                    </div>
                </div>
        )
}
const EmployeeMobileHeader: React.FC<{ doLogout: () => void, without?: boolean }> = ({doLogout}) => {
    const without = true;
    return (
            <div className={without ? "withoutbg" : ""}>
                <SadatJobsNavbar>
                    <NavbarEmployeeContent doLogout={doLogout}/>
                </SadatJobsNavbar>
            </div>
    )
}
const NavbarEmployeeContent: React.FC<{ doLogout: () => void }> = ({doLogout}) => {
    return (
            <React.Fragment>
                <Link to='/' className={classes.navElement}>
                    <p className={classes.navText}>الرئيسية</p>
                </Link>
                <Link to='/employee/status' className={classes.navElement}>
                    <p className={classes.navText}>التقديمات</p>
                </Link>
                <Link to='/employee/saved' className={classes.navElement}>
                    <p className={classes.navText}>المحفوظات</p>
                </Link>
                <Link to='/employee/profile' className={classes.navElement}>
                    <p className={classes.navText}>الصفحة الشخصية</p>
                </Link>
                <Link to='/employee/complaint' className={classes.navElement}>
                    <p className={classes.navText}>الإبلاغ عن مشكلة</p>
                </Link>
                <div className={classes.navElement} onClick={doLogout}>
                    <p className={classes.navText}>تسجيل خروج</p>
                </div>
            </React.Fragment>
    )
}